import * as React               from 'react';
import * as PropTypes           from 'prop-types';
import * as cx                  from 'classnames';
import {
    MessageTemplatesContainerProps,
    MessageTemplatesList as MessageTemplateListType,
    ViewContextTypes
}                               from './MessageTemplatesListTypes';
import { Recipient }            from '../../types';
import MessageTemplateComponent from '../MessageTemplate';
import icons                    from '../../icons';
import { haveMessageTemplate }  from '../../helpers/messenger';
// import segmentService           from '../../services/SegmentService';
import EducationCardsModal      from '../EducationCards';
import { LanguageToggle } from '../../components/LanguageToggle';

function mapMessageTemplates(messageTemplates: MessageTemplateListType, selectMessageTemplate, activeLanguage, activeMessageTemplate, viewContext, setInputView, conversationId: number, recipient: Recipient) {
    return messageTemplates.map(messageTemplate => (
        <MessageTemplateComponent
            recipient={recipient}
            activeLanguage={activeLanguage}
            conversationId={conversationId}
            activeMessageTemplate={activeMessageTemplate}
            key={messageTemplate.id}
            messageTemplate={messageTemplate}
            selectMessageTemplate={selectMessageTemplate}
            viewContext={viewContext}
            setInputView={setInputView}
        />
    ));
}

const MessageTemplatesList: React.StatelessComponent<MessageTemplatesContainerProps> = ({ location, activeLanguage, selectMessageTemplate, conversationId, activeMessageTemplate, recipient, viewContext, setInputView, data, loadMoreData, loadNextPage, loadPrevPage, showCards, session, templateLanguages }, {translate}) => {

    const isLastPage = data.messageTemplates.pageInfo.current === data.messageTemplates.pageInfo.totalPages;
    const isFirstPage = data.messageTemplates.pageInfo.current === 1;
    const haveTemplate = haveMessageTemplate(data.messageTemplates);
    const { features } = session;
    // check if language is non specified, in that case default to english.
    const checkLanguage = value => {
        if (value && value.length <= 3) {
            return value;
        }
        return 'en';
    };

    return (
        <div className={cx('messageTemplates messageTemplates__view', { [`messageTemplates__${viewContext}`]: Boolean(viewContext) })}>
            <div className="messageTemplates__container">
                    <div className="messageTemplates__prompt">
                    {viewContext === ViewContextTypes.MESSAGES_INPUT && features.includes(200) && <LanguageToggle
                                                                            context={viewContext}
                                                                            dealerLanguages={templateLanguages}
                                                                            recipientLanguage={checkLanguage(recipient.language)}
                                                                            features={features}
                                                                            translate={translate}
                                                                            />}
                    <EducationCardsModal translate={translate} showByDefault={showCards} />
                    {
                        viewContext !== ViewContextTypes.MESSAGES_INPUT &&
                        <>
                            <div className="messageTemplates__prompt-intro">{translate('choose_conversation_starter')}{recipient.name ? ` ${translate('for')}` : ''}</div>
                            <div className="messageTemplates__prompt-customerName">{recipient.name}</div>
                            {features.includes(200) && <LanguageToggle
                                context={viewContext}
                                dealerLanguages={templateLanguages}
                                recipientLanguage={checkLanguage(recipient.language)}
                                features={features} translate={translate}
                            />}
                        </>
                    }
                    </div>
                <div className={cx('messageTemplates__list', { 'messageTemplates__list-active': Boolean(activeMessageTemplate), [`messageTemplates__list--${viewContext}`]: Boolean(viewContext) })}>
                    {!haveTemplate && !activeMessageTemplate && viewContext === ViewContextTypes.MESSAGES_INPUT && (
                        <div className="messageTemplates__noTemplates">{translate('no_message_templates')}</div>
                    )}
                    {haveTemplate && mapMessageTemplates(data.messageTemplates.templates, selectMessageTemplate, activeLanguage, activeMessageTemplate, viewContext, setInputView, conversationId, recipient)}
                    {haveTemplate && !activeMessageTemplate && !isLastPage && viewContext !== ViewContextTypes.MESSAGES_INPUT && (
                        <div className="showMoreButton">
                            <button className="actionButton actionButton--inverse" onClick={loadMoreData}>{translate('show_more')}</button>
                        </div>
                    )}
                </div>
                {haveTemplate && !activeMessageTemplate && viewContext === ViewContextTypes.MESSAGES_INPUT && (
                    <div className={cx('messageTemplates__actionButtons', { [`messageTemplates__actionButtons--${viewContext}`]: Boolean(viewContext) })}>
                        <div className="messageTemplates__actionButtons--pagination">
                            <button
                                className={cx('actionButton actionButton--inverse', { 'actionButton--disabled': isFirstPage })}
                                disabled={isFirstPage}
                                onClick={loadPrevPage}
                            >
                                {icons.chevronLeft}
                            </button>
                            <button
                                className={cx('actionButton actionButton--inverse', { 'actionButton--disabled': isLastPage })}
                                disabled={isLastPage}
                                onClick={loadNextPage}
                            >
                                {icons.chevronRight}
                            </button>
                        </div>
                        <button className="actionButton actionButton--edit" onClick={() => selectMessageTemplate(data.messageTemplates.templates[0].id)}>{translate('edit')} & {translate('send')}</button>
                    </div>
                )}
            </div>
        </div >
    );
};

export default MessageTemplatesList;

MessageTemplatesList.contextTypes = {
    translate: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./src/sections/MessageTemplatesList/MessageTemplatesListComponent.tsx